import React from 'react';
import { LivingDocuments } from 'components/LivingDocuments';

export const EverydayLife = () => (
  <LivingDocuments category="home" />
);
